module.exports = __webpack_public_path__ + "img/electric-car.5c9859f1.png";